<template>
  <vx-card
    id="app_body"
    class="flex-1 flex-col w-full relative overflow-x-hidden"
  >
    <template slot="no-body">
      <global-header :buttonBack="true" :actions="false"></global-header>
      <div class="w-full p-5 pt-0">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="mb-1 flex">Pilih Penilai SKP : </label>
            <vs-select :options="listPengguna" v-model="selectedPenilaiSkp"/>
          </div>
        </div>
        <div class="vx-row mb-5 flex flex-col md:flex-row md:items-center">
          <div class="vx-col w-full">
            <label for="" class="mb-1 flex">Pilih Periode SKP (Bulan dan Tahun) : </label>
            <flat-pickr
              :config="configdateTimePicker"
              v-model="input.periode_skp"
              class="w-full"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-button @click="downloadSkp()">Download SKP</vs-button>
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
import { digofHttp as axios } from "@/axios";
import { ALL as ALL_PENGGUNA } from "@/query/pengguna.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "LaporanSkpCreate",
  components: {
    "vs-select": vSelect,
    flatPickr
  },
  data() {
    return {
      input: {
        penilai_id: null,
        periode_skp: null,
        pengguna_id: this.$sanctum.getUser().id
      },
      selectedPenilaiSkp: {value: null, label: 'Pilih Penilai'},
      listPengguna: [],
      listMonth: [
        {value: 1, label: 'January'},
        {value: 2, label: 'February'},
        {value: 3, label: 'Maret'},
      ],
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m",
        time_24hr: false
      }
    };
  },
  apollo: {
    listPengguna: {
      query: ALL_PENGGUNA,
      update: data => {
        let pengguna = data.pengguna.data.map(item => {
          return {value: item.id, label: item.nama};
        });
        pengguna.unshift({value : '', label : 'Pilih Pengguna'});
        return pengguna;
      },
      variables() {
        return {
          perPage: 10000
        };
      }
    }
  },
  created() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Buat Laporan SKP");
  },
  watch: {
    selectedPenilaiSkp: {
      handler(){
        this.input.penilai_id = this.selectedPenilaiSkp.value;
      }
    }
  },
  methods: {
    downloadSkp(){
      axios({
        url: "laporan-skp/download",
        method: "post",
        data: this.input
      })
      .then(response => {
        console.log(response);
        this.$vs.notify({
          title: "Sukses",
          text: "Berhasil melakukan download skp.",
          color: "success",
          position: "top-right"
        });
      }).catch(e => {
        console.error(e);
        this.$vs.notify({
          title: "Gagal",
          text: "Terjadi kesalahan, silahkan hubungi tim IT.",
          color: "danger",
          position: "top-right"
        });
      });
    }
  }
};
</script>
